import { BaseContract } from '../common/base.contract';
import { Contract, JsonRpcProvider, parseUnits } from 'ethers';
import RoundFactoryFacetAbi from '../../abi/Facets/RoundFactoryFacet.json';
import { RoundInfo } from '../../model/round.model';
import { mapRoundInfo } from '../../mappers/round-factory.mapper';


export class RoundFactoryFacet extends BaseContract {
    constructor(address: string, provider: JsonRpcProvider) {
        super(new Contract(address, RoundFactoryFacetAbi.abi, provider));
    }

    getAllSaleRoundDetails = async (): Promise<RoundInfo[]> => {
        try {
            const signedContract = await this._getSignedContract();
            
            // Check if the method exists
            if (!signedContract.getAllSaleRoundDetails) {
                throw new Error('getAllSaleRoundDetails method not found on contract');
            }
            
            const rounds = await signedContract.getAllSaleRoundDetails();
            
            // Handle empty response
            if (!rounds || rounds.length === 0) {
                console.log('No sale rounds found');
                return [];
            }
            
            return rounds.map((data: any) => mapRoundInfo(data));
        } catch (error: any) {
            if (error.code === 'BAD_DATA' && error.value === '0x') {
                console.log('Contract returned empty data - no sale rounds exist');
                return []; // Return empty array instead of throwing
            }
            throw error;
        }
    }

    checkRoundExists = async (roundId: string): Promise<boolean> => {
        return await this.contract.checkRoundExists(roundId);
    }

    // Méthodes d'écriture
    doCreateRound = async (
        newRoundId: string,
        isPublic: boolean,
        isStakable: boolean,
        allocationPercentage: number,
        cliffPeriod: number,
        vestingPeriod: number,
        stakingRewardPercentage: number,
        tokenPriceAsUsdc: bigint
    ) => {
        const contractWithSigner = await this._getSignedContract();
        const tx = await contractWithSigner.doCreateRound(
            newRoundId,
            isPublic,
            isStakable,
            allocationPercentage,
            cliffPeriod,
            vestingPeriod,
            stakingRewardPercentage,
            tokenPriceAsUsdc
        );
        await tx.wait();
    }

    doInitExistingRounds = async () => {
        const contractWithSigner = await this._getSignedContract();
        const tx = await contractWithSigner.doInitExistingRounds();
        await tx.wait();
    }
} 
